module.exports = __webpack_public_path__ + "img/67.4a6ed7f1.jpg";